<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true" size="xl">
        <div slot="modal-header" class="w-100">
            <div class="row">
                <div class="col-12 col-md-8">
                    <div style="font-weight: bold; color: #404040;">
                        Бахоланган қиймат: <span v-if="realEstate.evlTotal">{{realEstate.evlTotal | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="float-right d-flex">
                        <button class="all-btn add-btn" @click="save" v-if="canSave">
                            {{$t("action.save")}}
                        </button>
                        <button class="all-btn delete-btn ml-2"
                                v-if="canReject && hasPermission('REAL_ESTATE_REJECT')"
                                @click="canEvaluate">
                            <i class="fa fa-reply"></i>
                            <span>Рад қилиш</span>
                        </button>
                        <button class="all-btn delete-btn ml-2" @click="close">Ёпиш</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-header">
                            <div class="row" v-if="realEstate.type === 'BASIC'">
                                <div class="col-12">
                                    <div :class="{invalid : $v.realEstate.approach.$error}">
                                        <div class="form-check pl-0 checkbox-inline">
                                            <label class="form-check-label"
                                                   style="padding-left:22px !important">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="realEstate.approachCost"
                                                >
                                                <span class="form-check-sign"></span>
                                                {{$t("realEstate.approach.expense")}}
                                            </label>
                                        </div>
                                        <div class="form-check checkbox-inline">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="realEstate.approachIncome"
                                                       :disabled="isNoChangeIncome"
                                                >
                                                <span class="form-check-sign"></span>
                                                {{$t("realEstate.approach.income")}}
                                            </label>
                                        </div>
                                        <div class="form-check checkbox-inline">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="realEstate.approachComparative"
                                                >
                                                <span class="form-check-sign"></span>
                                                {{$t("realEstate.approach.comparative")}}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-lg-7">
                                    <div class="container-fluid">
                                        <carousel :perPage="1"
                                                  :navigationEnabled="true"
                                                  :navigationNextLabel="next"
                                                  :navigationPrevLabel="prev">
                                            <slide v-for="(photo) in buildingPhotos" v-bind:key="photo.id">
                                                <div v-if="photo && photo.type !== 'application/pdf'">
                                                    <!--<img :src="photo.filePath" width="100%" style="height: 500px;" :style="rotateStyle" />-->
                                                    <inner-image-zoom :src="photo.filePath"
                                                                      :style="rotateStyle"
                                                                      width="100%"
                                                                      height="500px"
                                                                      hideHint="true"
                                                                      zoomScale="1.2"
                                                    ></inner-image-zoom>
                                                </div>
                                                <div v-else-if="photo && photo.type === 'application/pdf'">
                                                    <iframe :src="photo.filePath" width="100%" style="height: 600px"></iframe>
                                                </div>
                                            </slide>
                                        </carousel>
                                        <div class="text-center mt-3 d-flex justify-content-center">
                                            <button class="all-btn add-btn mr-3" @click="rotateRight">
                                                <i class="fa fa-mail-reply"></i>
                                            </button>
                                            <button class="all-btn add-btn" @click="rotateLeft">
                                                <i class="fa fa-mail-forward"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-5" style="overflow: scroll;max-height: 600px">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.ownerClient")}} <span class="red">*</span></label>
                                        <v-select v-model="realEstate.owner" label="text"
                                                  :options="owners"
                                                  :filterable="false"
                                                  @search="onOwnerSearch"
                                                  @search:focus="onOwnerFocus"
                                                  :disabled="!isEditable || disableFields"
                                                  :readonly="disableFields">
                                            <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.text"></div>
                                            </template>
                                            <template slot="selected-option"
                                                      v-if="realEstate && realEstate.owner && realEstate.owner.text">
                                                <div v-html="realEstate.owner.text"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
<!--                                        <div class="red" v-if="$v.realEstate.owner.$error">-->
<!--                                            {{$t("realEstate.validation.ownerClient")}}-->
<!--                                        </div>-->
                                    </div>

                                    <div class="form-group">
                                        <div class="form-check pl-0">
                                            <label class="form-check-label" style="padding-left:22px !important">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="realEstate.hasCustomer" :disabled="disableFields" :readonly="disableFields">
                                                <span class="form-check-sign"></span>
                                                {{$t("realEstate.field.withLetterOfAttorney")}}
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-group" v-if="realEstate.hasCustomer">
                                        <label>{{$t("realEstate.field.withLetterOfAttorneyOwner")}} <span
                                                class="red">*</span></label>
                                        <v-select v-model="realEstate.customer" label="text"
                                                  :options="customers"
                                                  :filterable="false"
                                                  @search="onCustomerSearch"
                                                  @search:focus="onCustomerFocus"
                                                  :class="{invalid : $v.realEstate.customer.$error}"
                                                  :disabled="disableFields"
                                                  :readonly="disableFields"
                                        >
                                            <template slot="option" slot-scope="option" v-if="option && option.text">
                                                <div v-html="option.text"></div>
                                            </template>
                                            <template slot="selected-option"
                                                      v-if="realEstate && realEstate.customer && realEstate.customer.text">
                                                <div v-html="realEstate.customer.text"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                        <div class="red" v-if="$v.realEstate.customer.$error">
                                            {{$t("realEstate.validation.withLetterOfAttorneyOwner")}}
                                        </div>
                                    </div>
                                    <div :class="{invalid: $v.buildingType.code.$error}">
                                        <div class="form-group">
                                            <label>{{$t("realEstate.field.buildingType")}} <span
                                                    class="red">*</span></label>
                                            <v-select v-model="buildingType" label="name"
                                                      :options="buildingTypes"
                                                      :filterable="false"
                                                      @search:focus="onBuildingFocus"
                                                      @change="onChangeBuildingType"
                                                      :disabled="disableFields"
                                                      :readonly="disableFields"
                                            >
                                                <template slot="option" slot-scope="option"
                                                          v-if="option && option.name">
                                                    <div v-html="option.name"></div>
                                                </template>
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div v-if="!isMultiStorey && !isResidential" :class="{invalid: $v.subBuildingType.code.$error}">
                                      <div class="form-group">
                                        <label>{{$t("newRealEstate.field.plus.subBuildingType")}} <span class="red">*</span></label>
                                        <v-select v-model="subBuildingType" label="name"
                                                  :options="subBuildingTypes"
                                                  :filterable="false"
                                                  @search="subBuildingTypeSearch"
                                                  @search:focus="subBuildingTypeFocus"
                                        >
                                          <template slot="option" slot-scope="option" v-if="option && option.name">
                                            <div v-html="option.name"></div>
                                          </template>
                                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                      </div>
                                    </div>
                                    <div :class="{invalid: $v.architecturalStyle.code.$error}">
                                        <div class="form-group">
                                            <label>{{$t("realEstate.field.architecturalStyle")}} <span
                                                    class="red">*</span></label>
                                            <v-select v-model="architecturalStyle" label="displayName"
                                                      :options="architecturalStyles"
                                                      :filterable="false"
                                                      :clearable="false"
                                                      @search:focus="onArchitecturalStyleFocus"
                                                      :disabled="disableFields"
                                                      :readonly="disableFields"
                                            >
                                                <template slot="option" slot-scope="option"
                                                          v-if="option && option.displayName">
                                                    <div v-html="option.displayName"></div>
                                                </template>
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div :class="{invalid: $v.specialComfort.code.$error}">
                                        <div class="form-group">
                                            <label>{{$t("realEstate.field.specialComfort")}} <span class="red">*</span></label>
                                            <v-select v-model="specialComfort" label="displayName"
                                                      :options="specialComforts"
                                                      :filterable="false"
                                                      @search:focus="onSpecialComfortFocus"
                                                      :disabled="disableFields"
                                                      :readonly="disableFields"
                                            >
                                                <template slot="option" slot-scope="option"
                                                          v-if="option && option.displayName">
                                                    <div v-html="option.displayName"></div>
                                                </template>
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div :class="{invalid: $v.repairCondition.code.$error}">
                                        <div class="form-group">
                                            <label>{{$t("realEstate.field.repairConditions")}} <span
                                                    class="red">*</span></label>
                                            <v-select v-model="repairCondition" label="displayName"
                                                      :options="repairConditions"
                                                      :filterable="false"
                                                      @search:focus="onRepairFocus"
                                                      @change="onRepairChange"
                                                      :disabled="disableFields"
                                                      :readonly="disableFields"
                                            >
                                                <template slot="option" slot-scope="option"
                                                          v-if="option && option.displayName">
                                                    <div v-html="option.displayName"></div>
                                                </template>
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.constructionCompletion")}} <span
                                                class="red">*</span></label>
                                        <numeric-input v-model="realEstate.constructionCompletion" :max="100"
                                                       :precision="2"
                                                       :disabled="disableFields"
                                                       :readonly="disableFields"
                                        ></numeric-input>
                                        <div class="red" v-if="$v.realEstate.constructionCompletion.$error">
                                            {{$t("newRealEstate.validation.constructionCompletion")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.areaTotal")}} <span class="red">*</span></label>
                                        <numeric-input v-model="realEstate.evlGroundArea"
                                                       :precision="2"
                                                       :disabled="disableFields"
                                                       :readonly="disableFields"
                                        ></numeric-input>
                                        <div class="red" v-if="$v.realEstate.evlGroundArea.$error">
                                            {{$t("realEstate.validation.areaTotal")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.areaUnderConstruction")}} <span
                                                class="red">*</span></label>
                                        <numeric-input v-model="realEstate.evlBuildingWidthArea"
                                                       :precision="2"
                                                       :class="{invalid : $v.realEstate.evlBuildingWidthArea.$error}"
                                                       :disabled="disableFields"
                                                       :readonly="disableFields"
                                        ></numeric-input>
                                        <div class="red" v-if="$v.realEstate.evlBuildingWidthArea.$error">
                                            {{$t("realEstate.validation.areaUnderConstruction")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.areaUseful")}} <span class="red">*</span></label>
                                        <numeric-input v-model="realEstate.evlUsefulField" :precision="2"
                                                       :class="{invalid : $v.realEstate.evlUsefulField.$error}"
                                                       @input="onChangeUsefulArea"
                                                       :disabled="disableFields"
                                                       :readonly="disableFields"
                                        ></numeric-input>
                                        <div class="red" v-if="$v.realEstate.evlUsefulField.$error">
                                            {{$t("realEstate.validation.areaUseful")}}
                                        </div>
                                    </div>

                                  <div class="form-row align-items-center">
                                    <div class="col-md-6">
                                      <div class="form-group">
                                        <label>
                                          {{$t("realEstate.field.evlTotalArea")}} <span v-if="hasTotalArea" class="red">*</span>
                                        </label>
                                        <numeric-input v-model="realEstate.evlTotalArea" :precision="2"
                                                       :class="{invalid : $v.realEstate.evlTotalArea.$error}"
                                                       :disabled="isUserSpecial"
                                        ></numeric-input>
                                        <div class="red" v-if="$v.realEstate.evlTotalArea.$error">
                                          {{$t("realEstate.validation.evlTotalArea")}}
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="form-group">
                                        <div class="form-check pl-0">
                                          <label class="form-check-label text-uppercase" style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="realEstate.hasTotalArea"
                                                   :disabled="isUserSpecial"
                                            >
                                            <span class="form-check-sign"></span>
                                            {{$t("realEstate.field.hasTotalArea")}}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                    <div class="form-group">
                                        <label>{{$t('realEstate.field.storey')}}</label>
                                        <select class="form-control"
                                                v-model="realEstate.storey"
                                                @input="onChangeStorey"
                                                :class="{invalid: $v.realEstate.storey.$error}"
                                                :disabled="disableFields"
                                                :readonly="disableFields"
                                        >
                                            <option :value="option.value"
                                                    v-for="option in ref.storeys"
                                                    :key="option.label">{{option.label}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group" v-if="!isSeparateBuilding">
                                        <label>{{$t('realEstate.field.floor')}}</label>
                                        <select class="form-control"
                                                v-model="realEstate.floor"
                                                :class="{invalid: $v.realEstate.floor.$error}"
                                                :disabled="disableFields"
                                                :readonly="disableFields"
                                        >
                                            <option :value="option.value"
                                                    v-for="option in ref.floors"
                                                    :key="option.label">{{option.label}}
                                            </option>
                                        </select>
                                    </div>

                                    <div :class="{invalid: $v.wall.code.$error}">
                                        <div class="form-group">
                                            <label>{{$t("realEstate.field.constructiveElement")}} <span
                                                    class="red">*</span></label>
                                            <v-select v-model="wall" label="displayName"
                                                      :options="walls"
                                                      :filterable="false"
                                                      @search:focus="onConstructiveElementFocus"
                                                      :disabled="disableFields"
                                                      :readonly="disableFields"
                                            >
                                                <template slot="option" slot-scope="option"
                                                          v-if="option && option.displayName">
                                                    <div v-html="option.displayName"></div>
                                                </template>
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                        </div>
                                    </div>
                                   <template v-for="(field,index) in cadastreBuildingFields2">
                                       <div class="form-group" :key="field.code">
                                           <label v-if="hasBasementField(field.code) && hasElevatorField(field.code)">
                                               <div v-if="field.code == 'housing_type'">
                                                   {{$t(realEstate.category === 'Residential' ?
                                                   'realEstate.category.residential.label' :
                                                   'realEstate.category.notorious.label')}} {{$t('realEstate.field.housingType')}}
                                               </div>
                                               <div v-else>{{field.name}} <span class="red">*</span></div>
                                           </label>
                                           <template v-if="field.type === 'DECIMAL'">
                                               <numeric-input v-model="field.value2" :precision="2"
                                                              :class="{invalid : $v.cadastreBuildingFields2.$each[index].value2.$error}"
                                                              @change="onFieldValueChange(field)"
                                                              :disabled="disableFields && !(field.code === 'height')"
                                                              :readonly="disableFields && !(field.code === 'height')"
                                               ></numeric-input>
                                               <div class="red" v-if="field.code==='height_inner' && $v.validHeightInner.$error">Ички баландлиги ташқи баландликдан кичик булиши зарур!</div>
                                           </template>
                                           <template v-else-if="field.type === 'LISTBOX' && hasBasementField(field.code) && hasElevatorField(field.code)">
                                               <select class="form-control" v-model="field.value2"
                                                       :class="{invalid : $v.cadastreBuildingFields2.$each[index].value2.$error}"
                                                       @change="onFieldValueChange(field)"
                                                       :disabled="disableFields && !(field.code === 'housing_type')"
                                                       :readonly="disableFields && !(field.code === 'housing_type')"
                                               >
                                                   <option :value="option.id"
                                                           v-for="option in cadastreBuildingFieldReferences[field.reference.code]"
                                                           :key="option.id">{{option.name}}
                                                   </option>
                                               </select>
                                           </template>
                                           <template v-else-if="field.type === 'MULTISELECT'">
                                               <treeselect class="form-control" v-model="field.selected2"
                                                           :multiple="true"
                                                           placeholder="Танланг..."
                                                           :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                                           @input="onFieldValueChange(field)"
                                                           :class="{invalid : $v.cadastreBuildingFields2.$each[index].value2.$error}"
                                                           :disabled="disableFields && !(field.code === 'electrical_devices')"
                                                           :readonly="disableFields && !(field.code === 'electrical_devices')"
                                               >
                                               </treeselect>
                                           </template>
                                       </div>
                                    </template>
                                </div>
                            </div>
                            <div class="row" v-if="isBuilding">
                                <div class="col-12">
                                    <div class="section-header">
                                        <h4 class="pull-left">
                                            Бинолар
                                        </h4>
                                    </div>
                                    <ActBuildingCalculatedView :data="building"
                                                               :init-data="cadastreInitData"></ActBuildingCalculatedView>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <loading :active.sync="processing" :is-full-page="true"></loading>
            <template>
                <b-modal v-model="showReject" title="Кўчмас мулкни бекор қилиш">
                    <div class="container-fluid">
                        <div class="form-group">
                            <label>Бекор қилиш сабабини киритинг<span class="red">*</span></label>
                            <textarea class="form-control"
                                      v-model="realEstate.reasonDesc">
                        </textarea>
                        </div>
                    </div>
                    <div slot="modal-footer">
                        <button
                                type="button"
                                class="all-btn add-btn float-right ml-2"
                                @click="rejectAppraisal('Rejected')"
                        >{{$t("action.save")}}
                        </button>
                        <button
                                type="button"
                                class="all-btn delete-btn float-right"
                                @click="rejectModalHide"
                        >{{$t("action.cancel")}}
                        </button>
                    </div>
                </b-modal>
            </template>
        </div>
        <div slot="modal-footer" style="width: 100%">
            <template v-if="isBuilding">
                <button class="all-btn add-btn float-left" @click="prevAct">
                    <i class="fa fa-arrow-left"></i>
                    Олдинги
                </button>
                <button class="all-btn add-btn float-left ml-3" @click="nextAct">
                    Кейинги
                    <i class="fa fa-arrow-right"></i>
                </button>
            </template>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required, requiredUnless, minValue} from 'vuelidate/lib/validators';
    import {Carousel, Slide} from 'vue-carousel';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import Treeselect from '@riophae/vue-treeselect';
    import ActBuildingCalculatedView from "../ActBuildingCalculatedView";
    import initFilterModel from '@/shared/filter';
    import InnerImageZoom from 'vue-inner-image-zoom';
    import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison';
    import AdvancedFilter from '@/shared/filters/advancedFilter'
    import {parseToData} from '@/shared/real-estate-utils'
    import {mapState} from "vuex";

    export default {
        name: "NewRealEstateActModal",
        props: {
            disableFields: {
              type: Boolean,
              default: false
            }
        },
        components: {
            ActBuildingCalculatedView,
            'b-modal': bModal,
            Carousel,
            Slide,
            Loading,
            Treeselect,
            'inner-image-zoom': InnerImageZoom
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                processing: false,
                modelLastChangeTime: new Date().getTime(),
                ownerFilter: initFilterModel(),
                customerFilter: initFilterModel(),
                filterBuildingType: new AdvancedFilter(),
                show: false,
                showReject: false,
                realEstateId: null,
                realEstate: {},
                repairConditions: [],
                repairCondition: null,
                architecturalStyle: null,
                architecturalStyles: [],
                specialComfort: null,
                specialComforts: [],
                index: 0,
                building: {},
                buildingPhotos: [],
                walls: [],
                wall: null,
                buildingTypes: [],
                buildingType: {},
                cadastreBuildingFields: [],
                cadastreBuildingFields2: [],
                cadastreBuildingFieldsClone2: [],
                cadastreBuildingFieldReferences: {},
                cadastreBuildingDepreciationFields: [],
                prev: '<i class="material-icons">keyboard_arrow_left</i>',
                next: '<i class="material-icons">keyboard_arrow_right</i>',
                sectionFields: {
                    fields: ["basement_building_type", "housing_type", "repair", "height", "height_inner", "foundation", "wall", "house_cover", "house_top", "floor_type", "electrical_devices", "height", "height_inner", "elevator", "window", "door"]
                },
                cadastreInitData: {},
                owners: [],
                customers: [],
                turn: 0,
                ref: {
                    ...COMPARISON_REFERENCES
                },
                subBuildingType: null,
                subBuildingTypes: [],
                minValueUsefulArea: 0.01,
                minEvlTotalArea: 0,
            }
        },
        validations() {
            return {
                realEstate: {
                    // owner: {
                    //     required: required
                    // },
                    customer: {
                        required: requiredUnless(() => {
                            return !(this.realEstate.hasCustomer);
                        })
                    },
                    approach: {
                        required: requiredUnless(() => {
                            return !(!(this.realEstate.approachCost || this.realEstate.approachComparative || this.realEstate.approachIncome || this.realEstate.approachRegression));
                        })
                    },
                    /*RIGHT PANEL*/
                    evlGroundArea: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    evlBuildingWidthArea: {
                      required: requiredUnless(() => {
                        return !!this.isEvlTotalAreaEntered
                      })
                    },
                    evlUsefulField: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    evlTotalArea: {
                      required: requiredUnless(() => {
                        return !this.realEstate.hasTotalArea
                      }),
                      minValue: minValue(this.minEvlTotalArea)
                    },
                    constructionCompletion: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    storey: {
                        required: required,
                        minValue: minValue(1)
                    },
                    floor: {
                        required: requiredUnless(() => {
                            return !!(this.isSeparateBuilding)
                        })
                    }
                },
                architecturalStyle: {
                    code: {
                        required: required
                    }
                },
                repairCondition: {
                    code: {
                        required: required
                    }
                },
                specialComfort: {
                    code: {
                        required: required
                    }
                },
                wall: {
                    code: {
                        required: required
                    }
                },
                buildingType: {
                    code: {
                        required: required
                    }
                },
                cadastreBuildingFields2: {
                    $each: {
                        value2: {
                            required: requiredUnless(vm => {
                                return !(this.hasSectionField(vm.code) && this.hasBasementField(vm.code) && this.hasElevatorField(vm.code))
                            })
                        }
                    }
                },
                validHeightInner: {
                    required: requiredUnless(()=> {
                        return !!(this.hasHeightInnerValue)
                    })
                },
                // usefulAreaValid: {
                //     required: requiredUnless(() => {
                //         return !!this.isUsefulAreaValidation
                //     })
                // },
                subBuildingType: {
                  code: {
                    required: requiredUnless(() => {
                      return !!(this.isMultiStorey || this.isResidential || !this.subBuildingTypes.length)
                    })
                  }
                }
            }
        },
        computed: {
            ...mapState(['profile']),
            isNoChangeIncome() {
                return (this.repairCondition && this.repairCondition.code === 'wreckage') || this.realEstate.constructionCompletion < 100
            },
            checkedCustomFields() {
                return this.cadastreBuildingFields.filter((field) => {
                    return !field.system && this.hasField(field.code);
                });
            },
            isBuilding() {
                return this.realEstate && this.realEstate.buildings && this.realEstate.buildings.length > 0 && this.realEstate.type === 'BASIC'
            },
            canSave() {
                return (this.realEstate.status === 'Pending' || this.realEstate.status === 'AssignedToEvaluator'
                    || this.realEstate.status === 'NotFullyEvaluated' || this.realEstate.status === 'SentToComplement'
                    || (this.realEstate.status === 'Rejected' && this.realEstate.source === 'EXPERT2') || this.realEstate.status === 'ErrorInPrice');
            },
            isEditable() {
                return this.realEstate.status !== 'Confirmed';
            },
            rotateStyle() {
                return { transform: 'rotate(' + this.turn + 'turn)'}
            },
            hasHeightInnerValue() {
                let height = 0;
                let heightInner = 0;
                for (let i = 0; i <= this.cadastreBuildingFields2.length; i++) {
                    let field = this.cadastreBuildingFields2[i];
                    if (field && field.code === 'height') {
                        height = field.value2;
                    }
                    if (field && field.code === 'height_inner') {
                        heightInner = field.value2;
                    }
                    if (height > 0 && heightInner > 0) break;
                }
                return height > heightInner;
            },
            canReject() {
                return this.realEstate.status === 'AssignedToEvaluator' || this.realEstate.status === 'SentToComplement'|| (this.realEstate.status === 'NotFullyEvaluated' && this.isUserDirector);
            },
            isSeparateBuilding() {
                return (this.buildingType && this.buildingType.code !== 'RESIDENTIAL_MULTI_STOREY') && (this.realEstate.separateBuilding)
            },
            isBuildingMultiStorey() {
                return this.buildingType.code === 'RESIDENTIAL_MULTI_STOREY'
            },
            // isUsefulAreaValidation() {
            //
            //     let area = this.realEstate.evlGroundArea ? this.realEstate.evlGroundArea : 0;
            //     let areaBuilding = this.realEstate.evlBuildingWidthArea ? this.realEstate.evlBuildingWidthArea : 0;
            //
            //     let basementBuildingType = '';
            //     let usefulArea = this.realEstate.evlUsefulField ? this.realEstate.evlUsefulField : 0;
            //     let storey = this.realEstate.storey;
            //
            //     if (this.realEstate.data && this.realEstate.data.values) {
            //         const basement = this.realEstate.data.values['basement_building_type'];
            //         if (basement) {
            //             basementBuildingType = basement.code;
            //         }
            //     }
            //
            //     if (this.isBuildingMultiStorey) {
            //         return true;
            //     } else if (basementBuildingType === 'WITH_BASEMENT') {
            //       return (storey + 1) * area >= usefulArea || (storey + 1) * areaBuilding >= usefulArea;
            //     } else
            //         return storey * area >= usefulArea || storey * areaBuilding >= usefulArea;
            // },
            isBasementFloor() {
                return this.realEstate.floor === -1;
            },
            isMultiStorey() {
              return this.realEstate.buildingType && this.realEstate.buildingType === 'RESIDENTIAL_MULTI_STOREY'
            },
            isResidential() {
              return this.realEstate.buildingType && this.realEstate.buildingType === 'RESIDENTIAL_INDIVIDUAL'
            },
            isUserDirector() {
              return this.profile && this.profile.username === 'shohrux';
            },
            hasTotalArea() {
              return this.realEstate.hasTotalArea
            },
            isEvlTotalAreaEntered() {
              return !this.realEstate.evlBuildingWidthArea && this.realEstate.evlTotalArea && this.realEstate.evlTotalArea > 0
            },
            isUserSpecial() {
              return this.profile && (this.profile.username === 'kenjabek' || this.profile.username === 'urazboy' || this.profile.username === 'asadbek_baholovchi')
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.realEstateId;
                if (id && id > 0) {
                    const promises = [
                        this.$http.get('real-estate/' + id + '/building/init')
                    ];
                    promises.push(this.$http.get('admin/new-real-estate/' + id));
                    Promise.all(promises).then(function (values) {
                        const initData = values[0].data;

                        vm.cadastreInitData = initData;
                        vm.coefficient = initData.coefficient;

                        if (vm.cadastreBuildingFields2.length > 0) {
                            vm.cadastreBuildingFields2 = []
                        }

                        vm.sectionFields.fields.forEach((field) => {
                            const buildingField = initData.fields.filter((f) => f.code === field);
                            vm.cadastreBuildingFields2.push(buildingField[0])
                            vm.cadastreBuildingFieldsClone2 = JSON.parse(JSON.stringify(vm.cadastreBuildingFields2))
                        });

                        vm.cadastreBuildingFieldReferences = initData.references;

                        if (values.length >= 2) {
                            const editData = values[1].data;

                            if (editData.data && editData.data.values) {
                                vm.cadastreBuildingFields2.forEach((field) => {
                                    if (field.code && editData.data.values.hasOwnProperty(field.code)) {
                                        const fieldValue = editData.data.values[field.code];
                                        if (fieldValue) {
                                            if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                                                if (fieldValue.id && fieldValue.id > 0) {
                                                    field.value2 = fieldValue.id;
                                                    field.selected2 = vm.getReferenceById(field.reference.code, fieldValue.id);
                                                }
                                            } else if (field.type === 'MULTISELECT') {
                                                if (fieldValue) {
                                                    field.selected2 = [];
                                                    if (fieldValue.length > 0) {
                                                        fieldValue.forEach((ref) => {
                                                            field.selected2.push(ref.id);
                                                        });
                                                    } else if (fieldValue.hasOwnProperty('id') && fieldValue.id && fieldValue.id > 0) {
                                                        field.selected2.push(fieldValue.id);
                                                    }
                                                    field.value2 = field.selected2;
                                                }
                                            } else {
                                                field.value2 = fieldValue;
                                            }
                                        }
                                    }
                                });
                            }

                            if (!editData.data) {
                                editData.data = {};
                            }
                            if (!editData.data.values) {
                                editData.data.values = {};
                            }

                            vm.realEstate = editData;

                            if (editData.repairCondition) {
                                vm.initRepair();
                            }

                            if (editData.specialComfort) {
                                vm.initSpecialComfort()
                            }

                            if (editData.architecturalStyle) {
                                vm.initArchitecturalStyle()
                            }

                            if (editData.buildings && editData.buildings.length > 0) {
                                vm.editBuilding();
                            }

                            if (editData.wall) {
                                vm.initConstructiveElement();
                            }

                            if (editData.buildingType) {
                                vm.initBuildingType();
                            }

                            if (editData.status === 'AssignedToEvaluator' || (editData.status === 'Pending' && editData.source === 'INSIDE')) {
                              vm.searchRealEstateComparativeEvaluated({status: 'Confirmed', category: editData.category, cadastreDocNumber: editData.cadastreDocNumber})
                            }

                            vm.setAllDocuments();
                        }
                    });
                }
            },
            prevAct() {
                if (this.index !== 0) {
                    this.buildingPhotos = [];
                    this.index--;
                    this.editBuilding();
                }
            },
            nextAct() {
                if (this.index !== this.realEstate.buildings.length - 1) {
                    this.buildingPhotos = [];
                    this.index++;
                    this.editBuilding();
                }
            },
            close() {
                this.show = false;
                // this.$router.go(0);
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                if (this.repairCondition) {
                    this.realEstate.repairCondition = this.repairCondition.code;
                }

                if (this.wall) {
                    this.realEstate.wall = this.wall.code;
                }
                if (this.buildingType) {
                    this.realEstate.buildingType = this.buildingType.code;
                }

                if (this.specialComfort) {
                    this.realEstate.specialComfort = this.specialComfort.code
                }

                if (this.architecturalStyle) {
                    this.realEstate.architecturalStyle = this.architecturalStyle.code
                }

                this.$http.post('admin/new-real-estate', this.realEstate)
                    .then(res => {
                        this.processing = false;
                        if (res.data.status === "ERROR") {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: res.data.message,
                                type: 'warning'
                            });
                            return;
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.success'),
                                type: 'success'
                            });
                        }
                        this.show = false;
                        this.$router.go(0);

                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            editBuilding() {
                const vm = this;
                this.building = {};
                const buildingId = this.realEstate.buildings[this.index].id;
                if (buildingId && buildingId > 0) {
                    this.$http.get('new-real-estate/building/' + buildingId)
                        .then(res => {
                            if (res.data) {
                                vm.building = res.data;
                                vm.setBuildingPhotos()
                            }
                        }, err => {
                            console.log(err)
                        })
                }
            },
            onArchitecturalStyleFocus() {
                this.architecturalStyles = [];
                this.$http.get("admin/new-real-estate/architectural-styles")
                    .then(res => {
                        if (res.data && res.data.length > 0) {
                            this.architecturalStyles = res.data;
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            onSpecialComfortFocus() {
                this.specialComforts = [];
                this.$http.get('admin/new-real-estate/special-comports')
                    .then(res => {
                        if (res.data && res.data.length > 0) {
                            this.specialComforts = res.data;
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            onRepairFocus() {
                this.repairConditions = [];
                this.$http.get('uy-joy-api/repair-conditions')
                    .then(res => {
                        this.repairConditions = res.data;
                    }, err => {
                        console.log(err)
                    })
            },
            onRepairChange() {
                if (this.repairCondition && this.repairCondition.code === 'wreckage') {
                    this.realEstate.approachIncome = false;
                }
            },
            initRepair() {
                this.repairConditions = [];
                const vm = this;
                this.$http.get('uy-joy-api/repair-conditions')
                    .then(res => {
                        vm.repairConditions = res.data;
                        const repairConditions = vm.repairConditions.filter(r => r.code === vm.realEstate.repairCondition);
                        vm.repairCondition = repairConditions[0];
                    }, err => {
                        console.log(err)
                    })
            },
            initSpecialComfort() {
                this.specialComforts = [];
                const vm = this;
                this.$http.get('admin/new-real-estate/special-comports')
                    .then(res => {
                        if (res.data && res.data.length > 0) {
                            vm.specialComforts = res.data;
                            const specialComforts = vm.specialComforts.filter(s => s.code === vm.realEstate.specialComfort);
                            vm.specialComfort = specialComforts[0]
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            initArchitecturalStyle() {
                this.architecturalStyles = [];
                const vm = this;
                this.$http.get('admin/new-real-estate/architectural-styles')
                    .then(res => {
                        if (res.data && res.data.length > 0) {
                            vm.architecturalStyles = res.data;
                            const architecturalStyle = vm.architecturalStyles.filter(a => a.code === vm.realEstate.architecturalStyle);
                            vm.architecturalStyle = architecturalStyle[0]
                        }
                    }, err => {
                        console.log(err)
                    })
            },
            onConstructiveElementFocus() {
                const url = this.buildingType ? 'uy-joy-api/wall-types/' + this.buildingType.code : 'uy-joy-api/wall-types';
                this.$http.get(url)
                    .then(res => {
                        this.walls = res.data;
                    }, err => {
                        console.log(err);
                    });
            },
            initConstructiveElement() {
                const vm = this;
                const url = this.buildingType ? 'uy-joy-api/wall-types/' + this.buildingType.code : 'uy-joy-api/wall-types';
                this.$http.get(url)
                    .then(res => {
                        this.walls = res.data;
                        const walls = vm.walls.filter(w => w.code === vm.realEstate.wall);
                        vm.wall = walls[0];
                    }, err => {
                        console.log(err);
                    });
            },
            onBuildingFocus() {
                this.buildingTypes = [];
                this.filterBuildingType.cadastreType = this.realEstate.category
                this.filterBuildingType.onlyParentLookUp = true

                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        if (res.data !== "" && res.data.data.length > 0) {
                            this.buildingTypes = res.data.data;
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            onChangeBuildingType() {
                if (this.buildingType && this.buildingType.id > 0) {
                    this.purposeRentingAreas = [];
                    this.$http.get('rental-rates/purposes-renting-areas/tree-lookup/' + this.buildingType.code)
                        .then(res => {
                            this.purposeRentingAreas = res.data;
                        }, err => {
                            console.log(err);
                        });
                }
            },
            initBuildingType() {
                const vm = this;
                this.filterBuildingType.cadastreType = this.realEstate.category
                this.filterBuildingType.onlyParentLookUp = true

                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        if (res.data !== "" && res.data.data.length > 0) {
                            vm.buildingTypes = res.data.data;
                            const buildingTypes = vm.buildingTypes.filter(b => b.code === vm.realEstate.buildingType);
                            vm.buildingType = buildingTypes[0];
                            if (vm.realEstate.subBuildingType) {
                              vm.initSubBuildingType()
                            }
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            initSubBuildingType() {
              const vm = this;
              this.filterBuildingType.cadastreType = this.realEstate.category
              this.filterBuildingType.parent = this.buildingType.id
              this.filterBuildingType.onlyParentLookUp = false

              this.$http.post('building-type/list', this.filterBuildingType)
                  .then(res => {
                    if (res.data !== "" && res.data.data.length > 0) {
                      this.subBuildingTypes = res.data.data;
                      const subBuildingTypes = vm.subBuildingTypes.filter(b => b.code === vm.realEstate.subBuildingType);
                      vm.subBuildingType = subBuildingTypes[0];
                    }
                  }, err => {
                    console.log(err);
                  });
            },
            setAllDocuments() {
                this.realEstate.passport.forEach((file) => {
                    this.buildingPhotos.push(file);
                });

                this.realEstate.actOfSale.forEach((file) => {
                    this.buildingPhotos.push(file);
                });

                this.realEstate.decision.forEach((file) => {
                    this.buildingPhotos.push(file);
                });

                this.realEstate.playlist.forEach((file) => {
                    this.buildingPhotos.push(file);
                });

                this.realEstate.balance.forEach((file) => {
                    this.buildingPhotos.push(file);
                });

                this.realEstate.cadastre.forEach((file) => {
                    this.buildingPhotos.push(file);
                });

                this.realEstate.applicationForm.forEach((file) => {
                    this.buildingPhotos.push(file);
                });

                this.realEstate.documents.forEach((file) => {
                    this.buildingPhotos.push(file);
                });
                this.realEstate.photos.forEach((file) => {
                    this.buildingPhotos.push(file);
                });
            },
            setBuildingPhotos() {
                this.building.photos.forEach((file) => {
                    this.buildingPhotos.push(file);
                });
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            },
            canEvaluate() {
                this.realEstate.reasonDesc = '';
                this.showReject = true;
            },
            rejectAppraisal(status) {
                if (this.realEstate.reasonDesc) {
                    this.processing = true;
                    this.$http.post('admin/new-real-estate/status/reject', {
                        realEstateId: this.realEstate.id,
                        status: status,
                        reasonDesc: this.realEstate.reasonDesc
                    }).then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.showReject = false;
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.statusSuccess'),
                                type: 'success'
                            });
                            this.realEstate.status = status;
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.realEstate.statusWarning'),
                                type: 'warning'
                            });
                            this.showReject = false;
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.statusError'),
                            type: 'error'
                        });
                        this.showReject = false;
                        this.processing = false;
                    })
                } else {
                    this.$swal({
                        title: 'Хабар!',
                        text: 'Бекор қилиш сабабини киритинг!',
                        type: 'warning'
                    });
                }
            },
            rejectModalHide() {
                this.showReject = false;
            },
            hasSectionField(code) {
                if(code === 'height') {
                  return false
                }
                return this.sectionFields.fields.includes(code);
            },
            onFieldValueChange(field) {
                if (field) {
                    let fieldValue = {};
                    if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                        if (field.type === 'LISTBOX') {
                            field.selected2 = this.getReferenceById(field.reference.code, field.value2);
                        }
                        if (field.selected2) {
                            fieldValue = {
                                id: field.selected2.id,
                                code: field.selected2.code
                            }
                        }
                        if (field.type === 'COMBOBOX') {
                            field.value2 = fieldValue;
                        }
                    } else if (field.type === 'MULTISELECT') {
                        fieldValue = [];
                        if (field.selected2 && field.selected2.length > 0) {
                            field.selected2.forEach((ref_id) => {
                                const ref = this.getReferenceById(field.reference.code, ref_id);
                                if (ref) {
                                    fieldValue.push({
                                        id: ref.id,
                                        code: ref.code
                                    })
                                }
                            });
                        }
                        field.value2 = fieldValue;
                    } else {
                        fieldValue = field.value2;
                    }

                    if (!this.realEstate.data) {
                        this.realEstate.data = {
                            values: {
                                height: null,
                                height_inner: null,
                                foundation: null,
                                wall: null,
                                house_cover: null,
                                house_top: null,
                                floor_type: null,
                                window_and_doors: null,
                                electrical_devices: null
                            }
                        }
                    }
                    this.realEstate.data.values[field.code] = fieldValue;

                    let resultFields2 = [];
                    this.cadastreBuildingFields2.forEach((field2) => {
                        if (field2.code === field.code)  {
                            field2 = field;
                        }
                        resultFields2.push(field2)
                    });
                    this.cadastreBuildingFields2 = resultFields2;
                }
            },
            multiSelectOptions(options) {
                const items = [];
                if (options && options.length > 0) {
                    options.forEach((option) => {
                        items.push({
                            id: option.id,
                            label: option.name
                        });
                    });
                }
                return items;
            },
            onOwnerSearch(searchTxt, loading) {
                loading(true);
                this.owners = [];
                this.ownerFilter.search = searchTxt;
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onOwnerFocus() {
                this.owners = [];
                this.ownerFilter.search = '';
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onCustomerSearch(searchTxt, loading) {
                loading(true);
                this.customers = [];
                this.customerFilter.search = searchTxt;
                this.$http.post('customer/search', this.customerFilter)
                    .then(res => {
                        this.customers = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCustomerFocus() {
                this.customers = [];
                this.customerFilter.search = '';
                this.$http.post('customer/search', this.customerFilter)
                    .then(res => {
                        this.customers = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            rotateRight() {
                this.turn = this.turn - 0.25
            },
            rotateLeft() {
                this.turn = this.turn + 0.25
            },
            onChangeUsefulArea() {
                this.$v.usefulAreaValid.$touch()
            },
            onChangeStorey(val) {
                if (val > 0 && val < 2) {
                    this.realEstate.floor = val
                }
            },
            hasBasementField(code) {
                if (code === 'basement_building_type') {
                    return !this.isBasementFloor;
                }
                return true;
            },
            hasElevatorField(code) {
              if (code === 'elevator') {
                return !this.isResidential;
              }
              return true;
            },
            subBuildingTypeFocus() {
              if (!this.subBuildingTypes.length && this.buildingType) {
                this.filterBuildingType.cadastreType = this.realEstate.category
                this.filterBuildingType.parent = this.buildingType.id
                this.filterBuildingType.onlyParentLookUp = false

                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                      if (res.data !== "" && res.data.data.length > 0) {
                        this.subBuildingTypes = res.data.data;
                      }
                    }, err => {
                      console.log(err);
                    });
              }
            },
            subBuildingTypeSearch(searchTxt, loading) {
              loading(true);
              this.filterBuildingType.cadastreType = this.realEstate.category
              this.filterBuildingType.parent = this.buildingType.id
              this.filterBuildingType.onlyParentLookUp = false
              this.filterBuildingType.search = searchTxt;

              this.$http.post('building-type/list', this.filterBuildingType)
                  .then(res => {
                    if (res.data !== "" && res.data.data.length > 0) {
                      this.subBuildingTypes = res.data.data;
                    }
                    loading(false);
                  }, err => {
                    console.log(err);
                  });
            },
            searchRealEstateComparativeEvaluated(requestFilter) {
              this.processing = true
              const vm = this;

              this.$http.post('admin/v3/real-estate/search-comparative-evaluated', requestFilter)
                  .then(res => {
                    // console.log('search-comparative-evaluated act = ', res)
                    if (res && res.data && res.data.code !== 'NOT_FOUND') {
                      const searchingData = res.data
                      // console.log('searchingData = ', searchingData)

                      // const editRealEstateData =  JSON.parse(JSON.stringify(this.realEstate.data));
                      // const resultRealEstateData = JSON.parse(JSON.stringify(searchingData.data));

                      // const data = updateDifferences(editRealEstateData, resultRealEstateData)

                      let realEstate = JSON.parse(JSON.stringify(this.realEstate))

                      // console.log('search-comparative-evaluated = ', data)
                      // realEstate.data = data
                      realEstate.name = searchingData.name
                      // realEstate.architecturalStyle = searchingData.architecturalStyle
                      realEstate.specialComfort = searchingData.specialComfort
                      realEstate.evlPropertyType = searchingData.evlPropertyType
                      // realEstate.repairCondition = searchingData.repairCondition
                      realEstate.sectionId = searchingData.sectionId

                      if (searchingData.mfy) {
                        realEstate.mfy = searchingData.mfy
                      }

                      realEstate.microRegionId = searchingData.microRegionId
                      // realEstate.subBuildingType = searchingData.subBuildingType
                      realEstate.buildingType = searchingData.buildingType
                      realEstate.isMicroRegionSelected = searchingData.isMicroRegionSelected
                      realEstate.separateBuilding = searchingData.separateBuilding

                      // vm.architecturalStyle = searchingData.architecturalStyleDto
                      vm.specialComfort = searchingData.specialComfortDto
                      // vm.repairCondition = searchingData.repairConditionDto

                      if (searchingData.buildingType) {
                        vm.initBuildingType()
                      }
                     /* if (searchingData.microRegionId) {
                        vm.onMfyChange()
                      } */

                      // console.log('this.realEstate.data1 = ', JSON.parse(JSON.stringify(this.realEstate.data)))
                      // console.log('this.cadastreBuildingFields1 = ', JSON.parse(JSON.stringify(this.cadastreBuildingFields)))

                      this.cadastreBuildingFields2 = JSON.parse(JSON.stringify(this.cadastreBuildingFieldsClone2))
                      this.realEstate = parseToData(realEstate, this.cadastreBuildingFields2, this.cadastreBuildingFieldReferences);

                      // console.log('this.realEstate.data2 = ', JSON.parse(JSON.stringify(this.realEstate.data)))
                      // console.log('this.cadastreBuildingFields2 = ', JSON.parse(JSON.stringify(this.cadastreBuildingFields)))
                    }

                    this.processing = false;

                  }).catch(({response}) => {
                console.log('error', response)
                this.processing = false;
            })
          },
        },
        created() {
            this.$eventBus.$on('showBuildingActModal', (realEstateId) => {
                if (realEstateId) {
                    this.realEstateId = realEstateId;
                    this.show = true;
                    this.init()
                }
            })
        },
        watch: {
          hasTotalArea : {
            handler: function (val) {
              if (val) {
                this.minEvlTotalArea = 0.01
                this.minValueUsefulArea = 0
              } else {
                this.minEvlTotalArea = 0
                this.minValueUsefulArea = 0.01
              }
            }
          }
        }
    }
</script>

<style scoped>

</style>